const isPermissionDenied = async (name: PermissionName) => {
  try {
    const result = await navigator.permissions.query({ name });
    return result.state === 'denied';
  } catch {
    return false;
  }
};

export const isMicPermissionsDenied = () =>
  isPermissionDenied('microphone' as PermissionName);
